import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Rating from './Rating';

const House = ({ house }) => {
  return (
    <Card className='my-3 p-3 rounded' style={{ maxHeight: '300px', overflow: 'hidden' }}>
      <Link to={`/house/${house._id}`}>
        {/* Render the first image as the main image */}
        {house.images?.[0] && (
          <Card.Img
            src={house.images[0]}
            variant='top'
            style={{ maxHeight: '150px', objectFit: 'cover' }}
          />
        )}
      </Link>

      <Card.Body>
        <Link to={`/house/${house._id}`}>
          <Card.Title as='div' className='house-title'>
            <strong>{house.name}</strong>
          </Card.Title>
        </Link>

        <Card.Text as='div' style={{ fontSize: '0.9rem', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
          <Rating
            value={house.rating}
            text={`${house.numReviews} reviews`}
          />
        </Card.Text>

        <Card.Text as='h3' style={{ fontSize: '1.2rem' }}>${house.price}</Card.Text>

        {/* Render thumbnails for additional images */}
        {house.images?.length > 1 && (
          <div className='image-thumbnails mt-2'>
            {house.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumbnail ${index + 1}`}
                style={{
                  width: '50px',
                  height: '50px',
                  marginRight: '5px',
                  objectFit: 'cover',
                  borderRadius: '5px',
                }}
              />
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default House;